import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import FunctionBar from './FunctionBar';
import TopTicker from './TopTicker';
import StatusBar from './StatusBar';
import MaintenanceBanner from '../MaintenanceBanner';
import AgentFloatingWindow from '../../AgentFloatingWindow';
import { newsIntelAPI, marketAPI } from '../../../services/api';
import { preloadNewsIntelligencePage, scheduleNewsIntelligencePreload } from '../../../modules/news-intelligence/preload';

const TerminalShell = ({ children }) => {
  const navigate = useNavigate();
  const [tickerArticles, setTickerArticles] = useState([]);
  const [tickerIndices, setTickerIndices] = useState([]);

  // News feed for ticker
  useEffect(() => {
    let cancelled = false;
    const fetchArticles = async () => {
      try {
        const res = await newsIntelAPI.listArticles({ limit: 30, days: 3 });
        if (!cancelled && res?.success) {
          setTickerArticles(res.articles || []);
          preloadNewsIntelligencePage().catch(() => {});
        }
      } catch { /* ticker is non-critical */ }
    };
    fetchArticles();
    const id = setInterval(fetchArticles, 5 * 60 * 1000);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  // Market indices for ticker
  useEffect(() => {
    let cancelled = false;
    const fetchIndices = async () => {
      try {
        const res = await marketAPI.getMarketOverview();
        if (!cancelled && res?.success) {
          setTickerIndices(res.indices || []);
        }
      } catch { /* non-critical */ }
    };
    fetchIndices();
    const id = setInterval(fetchIndices, 60_000);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  useEffect(() => scheduleNewsIntelligencePreload(), []);

  const handleArticleClick = useCallback((articleId) => {
    navigate(`/news-intelligence?article=${articleId}`);
  }, [navigate]);

  return (
    <div
      className="flex flex-col h-screen"
      style={{
        backgroundColor: 'var(--color-background)',
        color: 'var(--color-text)',
      }}
    >
      <MaintenanceBanner />
      <FunctionBar />
      {/* 全站统一一个 TopTicker — 包括新闻页面，避免多个 ticker 风格/速度不一致 */}
      <TopTicker
        articles={tickerArticles}
        indices={tickerIndices}
        onArticleClick={handleArticleClick}
      />
      <main
        className="flex-1 overflow-x-hidden overflow-y-auto"
        style={{ backgroundColor: 'var(--color-background)' }}
      >
        {children}
      </main>
      <StatusBar />
      {/* 全局 SAGAX Agent 浮动小窗 — 所有平台模块都有 */}
      <AgentFloatingWindow />
    </div>
  );
};

export default TerminalShell;
